<style scoped>
	#body {
		margin: 5px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	}
	
	.el-form-item {
		margin-bottom: 0px;
	}
	
</style>

<template>
	<div id="body">
		<div style="box-shadow: 1px 1px 10px #DCDCDC; height: 40px; background-color: white; display: flex; flex-direction: row; align-items: center; margin: 0 10px; padding: 5px 5px 5px 20px; border-radius: 10px;">
			<el-button icon="el-icon-refresh-right" circle  @click="refresh" style="margin-right: 20px;"></el-button>
			
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>模板广告设置</el-breadcrumb-item>
			  <el-breadcrumb-item>竞彩</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="margin-top: 10px; background-color: white; padding: 10px; margin: 10px; border-radius: 5px;">
			<div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%; margin-bottom: 10px;">
				<el-form :inline="true" class="demo-form-inline">
						
					<el-form-item>
						<el-button type="primary" @click="refresh">刷新</el-button>
						<el-button type="danger" @click="addAdFunc">添加广告</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-table :data="tableData" ref="myTable" border  style="width: 100%" 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				
				<el-table-column prop="id" label="编号" width="100"  align="center">
				</el-table-column>
				
				
				<el-table-column prop="ads_name" label="模板名称" align="center" >
				</el-table-column>
				
				<el-table-column prop="exam_img_url" label="示例图" align="center" >
					<template slot-scope="scope">
						<img previewImg(scope.row.exam_img_url) :src="scope.row.exam_img_url" style="width: 100px;  cursor: pointer;" />
					</template>
				</el-table-column>
				
				<el-table-column prop="ads_type" label="类型" align="center" >
					<template slot-scope="scope">
						<span v-if="scope.row.ads_type == 0">自行编辑</span>
						<span v-if="scope.row.ads_type == 1">图片轮询</span>
						<span v-if="scope.row.ads_type == 2">图片广告</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="ads_index" label="索引" align="center" >
				</el-table-column>
				
				<el-table-column prop="style_name" label="图片模板" align="center" width="300">
					<template slot-scope="scope">
						<div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
							<img @click="previewImg(item)" style="width: 220px; border:solid 1px #dcdcdc; margin-bottom: 5px; cursor: pointer;" v-if="scope.row.image_ids.length != 0" v-for="(item, index) in scope.row.image_ids" :src="item"/>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="sorts" label="排序" align="center" >
				</el-table-column>
				
				<el-table-column prop="add_time" label="操作" align="center" >
					<template slot-scope="scope">
						<el-button  type="primary" @click="edit_func(scope)">编辑</el-button>
						<el-button  type="danger" @click="delete_func(scope)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<el-pagination background layout="prev, pager, next" :key="tableKey" :page-size="limit" @current-change="getData" :total="total" style="margin-top: 20px;"></el-pagination>
		</div>
		
		<el-dialog :title="isEdit ? '编辑模板' : '添加模板'" :visible.sync="addView" width="800px" @close="closeAdDialog">
			<addAd
				:key="dialogKey"
				:is-edit="isEdit"
				:edit-data="payinOrder"
				@success="saveSuccess">
			</addAd>
		</el-dialog>
		
	</div>
</template>

<script>
	import addAd from './JcAction/JcAdAdd.vue';
	
	export default {
		name:'List',
		components:{
			addAd
		},
		data(){
			return {
				addView:false,
				isEdit:false,
				payinOrder:null,
				dialogKey:0,
				/* 搜索参数 */
				status:'',
				keyword:'',
				/* 表格参数 */
				tableKey:0,
				loading:false,
				limit:10,
				total:0,
				tableData: []
			}
		},
		created() {
			this.getData();
		},
		methods:{
			edit_func(scope){
				this.isEdit = true;
				this.payinOrder = Object.assign({}, scope.row);
				this.dialogKey++;
				this.addView = true;
			},
			previewImg(_img){
				window.open(_img);
			},
			delete_func(scope){
				let _this = this;
				_this.$api.post("/TplSet/deleteAd", {id:scope.row.id}).then(res=>{
					if(res.code == 1)
					{
						_this.tableData.splice(scope.$index, 1);
					}else{
						_this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
				});
			},
			changeStatus(scope){
				let _this = this;
				let _status = scope.row.status == 1 ? 0 : 1;
				_this.$api.post("/Ad/ChangeStatus", {id:scope.row.id, status:_status}).then(res=>{
					if(res.code == 1)
					{
						_this.tableData[scope.$index].status = _status;
					}else{
						_this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
				});
			},
			addAdFunc(){
				this.isEdit = false;
				this.payinOrder = null;
				this.dialogKey++;
				this.addView=true;
			},
			closeAdDialog(){
				this.addView = false;
				this.isEdit = false;
				this.payinOrder = null;
			},
			saveSuccess(){
				this.closeAdDialog();
				this.getData();
			},
			passAction(scope){
				this.addView = true;
				this.payinOrder = scope.row;
				console.log(scope);
			},
			refresh(){
				this.getData();
			},
			getData(page=1){
				let that = this;
				that.loading = true;
				that.$api.post("/TplSet/AdList", {game_type:'jc'}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			onSubmit(){
				this.getData();
			},
			statusChange(e){
				this.status = e;
				this.getData();
			},
		}
	}
</script>
